import {
    Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, Renderer2, ViewChild
} from '@angular/core';


import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';



export interface BackupsDataTable {
    dateCreated: string;
    name: string;
    sizeUI: string;
    envId: number;
    isValidated: boolean;
    version:string,
    action: string;
    description: string;
    backupDeployedPackagesOnly: boolean;
}

@Component({
    selector: 'backups-data',
    template: require('./backups-data.component.html'),
    styles: [require('./backups-data.component.scss')]
})


export class BackupsDataComponent {
    public projectId: any;
    public environmentId: string;
    @Output() public deleteItem = new EventEmitter();
    public get data() {
        return this._data;
    }

    @Input() public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((item) => {
                data.push({
                    id : item.id,
                    dateCreated: item.dateCreated, 
                    name :  item.name,
                    sizeUI: item.sizeUI ,
                    envId : item.envId,
                    isValidated : item.isValidated,
                    backupDeployedPackagesOnly : item.backupDeployedPackagesOnly,
                    version: item.version ,
                    description : item.description
                });
            });
            this.dataSource.data = data;
        }
    }



    // tslint:disable-next-line:variable-name
    private _data: any;

    public displayedColumns = ['DateCreated', 'Name', 'SizeUI', 'EnvId', 'IsValidated', 'BackupDeployedPackagesOnly', 'Version', 'Description','Action'];
    public dataSource = new MatTableDataSource<BackupsDataTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
    private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'DateCreated', width: 300 },
        { field: 'Name', width: 150 },
        { field: 'SizeUI', width: 150 },
        { field: 'EnvId', width: 50 },
        { field: 'IsValidated', width: 150 },
        { field: 'BackupDeployedPackagesOnly', width: 150 },
        { field: 'Version', width: 150 },
        { field: 'Description', width: 150 },
        { field: 'Action', width: 150 },
    ];

    constructor(
    
        @Inject('$stateParams') stateParams: any,
        private renderer: Renderer2

    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;

    }


    deleteBackups = (entity) => {
        this.deleteItem.emit({
            data : entity
        })
    }


    removeVersionFromEnvName(envName){
        return envName.split('_')[0];
    }

    convertUTCtoLocal(date) {
        if (!date)
            return;
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }


    private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
        this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }




    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
                }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/buckups-ang7/backups-data/backups-data.component.ts